export default "skymp5-front/d3b98871f5664db436199808ee3d834d.png";